module.exports = __webpack_public_path__ + "static/media/RequestPayment.827d3b4b.png";